import React, {useLayoutEffect,useState,useCallback,useEffect} from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
// import {
//     List, Edit, Create, Datagrid, Show, DateField, ReferenceManyField,
//     ReferenceField, TextField, ArrayField, ShowButton, SingleFieldList,
//     DisabledInput, ReferenceInput, AutocompleteInput,
//     SelectInput, SimpleForm, DeleteButton, NumberInput, DateInput, Filter, SimpleShowLayout, ImageInput, ImageField, EditButton, TopToolbar, required, SimpleFormIterator, ArrayInput, TextInput, 
// } from 'react-admin';

import { RUN_TIME_API_ENDPOINT, CommonHeaderOption } from './common/common';

const SapPayers =(props)=> {
    const [loadingShow, setLoadingShow] = useState(false);
    const [sap_products, setSapProduct] = useState([]);

    useLayoutEffect(() => {
        const options = CommonHeaderOption();
        const apiUrl = RUN_TIME_API_ENDPOINT;
        options.method = 'GET';
        setLoadingShow(true);
        fetch(`${apiUrl}/sap_contract_payers/${props.id}`, options)
        .then(res => {
            return res.json();
        }).then(jsonD => {
            let obj = {};
            obj.sap_products = jsonD.data;
            obj.loadingShow = false;
            setLoadingShow(false);
            setSapProduct(obj.sap_products)
        });
             
    }, []);


 
        return (
            <div>
            {
                !loadingShow &&
                <Scrollbars class="scroll-container">
                    <div {...props} title="Order Materials">
                        <div>
                            {   sap_products.length > 0 &&
                                <div className="data-box">
                                    <h2 className="data-heading">Contract Products for Contract No. : {props.id}</h2>
                                    <table className="data-table">
                                        <thead>
                                            <tr>
                                                <th> </th>
                                                <th>Payer Name </th>
                                                <th>Payer sap code </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                sap_products.map(items => {
                                                    
                                                    return (
                                                        <tr key={items.id}>
                                                            <td></td>
                                                            <td>{items.payer_name}</td>
                                                            <td>{items.payer_sap_code}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            }
                        </div>
                    </div>
                </Scrollbars>
            }
            </div>
        );
    
}
export default SapPayers;
